import CryptoJS from 'crypto-js'

function toBase64Url(base64: string): string {
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
}

export function generateClientToken(clientId: string, secret: string): string {
  const payload = { clientId, iat: Math.floor(Date.now() / 1000) }
  const payloadBase64url = toBase64Url(btoa(JSON.stringify(payload)))

  const signatureWordArray = CryptoJS.HmacSHA256(payloadBase64url, secret)
  const signatureBase64url = toBase64Url(
    CryptoJS.enc.Base64.stringify(signatureWordArray),
  )

  return `${payloadBase64url}.${signatureBase64url}`
}
